/**
 * Alveary API facade.
 *
 * Assembles the per-domain endpoint modules into the single `api` object the
 * UI consumes (`api.projects.list()`, `api.tokens.getAnalytics()`, …). The
 * module specifier `@/services/api` resolves here, so consumers and test
 * mocks are agnostic to the file layout behind the facade.
 *
 * Response caching is owned by TanStack Query at the hook layer — endpoint
 * methods construct requests and return domain data, nothing else. The
 * shared transport (auth interceptors, error normalization) lives in
 * ./client.ts; service modules with bespoke transport needs import the
 * client from there rather than through this facade.
 */

import { activities } from './activities'
import { admin } from './admin'
import { analytics } from './analytics'
import { auth } from './auth'
import { claimRecommendations } from './claimRecommendations'
import { claimReview } from './claimReview'
import { collectorMachines } from './collectorMachines'
import { collectors } from './collectors'
import { consolidation } from './consolidation'
import { dashboard } from './dashboard'
import { dispatch } from './dispatch'
import { home } from './home'
import { ideas } from './ideas'
import { intake } from './intake'
import { integrations } from './integrations'
import { knowledgeBase } from './knowledgeBase'
import { modelCapabilities } from './modelCapabilities'
import { modelCatalogue } from './modelCatalogue'
import { modelRelay } from './modelRelay'
import { prds } from './prds'
import { proceduralMemory } from './proceduralMemory'
import { projects } from './projects'
import { promptCategories } from './promptCategories'
import { prompts } from './prompts'
import { reminders } from './reminders'
import { semanticMemory } from './semanticMemory'
import { summarization } from './summarization'
import { telemetryPolicies } from './telemetryPolicies'
import { todos } from './todos'
import { tokens } from './tokens'
import { users } from './users'
import { usage } from './usage'

export const api = {
  projects,
  dashboard,
  collectors,
  collectorMachines,
  analytics,
  activities,
  proceduralMemory,
  knowledgeBase,
  tokens,
  todos,
  ideas,
  reminders,
  prds,
  prompts,
  promptCategories,
  dispatch,
  home,
  summarization,
  telemetryPolicies,
  users,
  auth,
  admin,
  intake,
  integrations,
  semanticMemory,
  claimReview,
  claimRecommendations,
  modelCapabilities,
  modelCatalogue,
  modelRelay,
  consolidation,
  usage,
}
